// German for the client page's rail: the five field labels and the BALL figure.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Engagements': 'Aufträge',
  'Day': 'Tag',
  'Ball': 'Ball',
  'Last contact': 'Letzter Kontakt',
  'New': 'Neu',
  'WITH {who}': 'BEI {who}',
}, 'ClientRail');
